import { render, staticRenderFns } from "./NormalChallengesTab.vue?vue&type=template&id=957ab7c6&scoped=true"
import script from "./NormalChallengesTab.vue?vue&type=script&lang=js"
export * from "./NormalChallengesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "957ab7c6",
  null
  
)

export default component.exports